<template>
  <div class="details">
    <div class="card br-2">
      <div class="p-10">
        <h6 class="fw-bold">RTSM Integrations</h6>
        <div v-if="!isPDFItem">
          <a href="" class="col-1 p-0 make-link" @click.prevent="expandAll()">Expand all</a>
          <span class="link_style"></span>
          <a href="" class="col-1 p-0 make-link" @click.prevent="collapseAll()">Collapse all</a>
        </div>
        <div class="pt-8">
          <div>
            <i class="fa fa-plus-circle pr-6" v-if="!showRTSMContent" @click.prevent="showRTSMContent = true" data-testid="rtsm-open-button"></i>
            <i class="fa fa-minus-circle pr-6" v-if="showRTSMContent" @click.prevent="showRTSMContent = false"></i>
            RTSM Vendor Information
          </div>
          <div v-if="showRTSMContent || isPDFItem">
            <div class="card inner-card br-2">
              <div :class="isPDFItem ? 'pt-10' : 'p-10'">
                <b-row v-if="rtsmDetails && (rtsmDetails.vendorSelected || rtsmDetails.studyCode)">
                  <b-col cols="2" :class="isPDFItem ? 'pl-0' : ''">
                    <div class="content" data-testid="rtsm-vendor-details">
                      RTSM Vendor
                    </div>
                    <div class="header">
                      {{ rtsmDetails.vendorSelected }}
                    </div>
                  </b-col>
                  <b-col>
                    <div class="content">
                      Sponsor Provided Study Code
                    </div>
                    <div class="header">
                      {{ rtsmDetails.studyCode }}
                    </div>
                  </b-col>
                </b-row>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "rtsm-details",
  data() {
    return {
      showRTSMContent: false
    };
  },
  props: {
    rtsmDetails: {
      type: Object,
      default: () => {}
    },
    isPDFItem: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    expandAll() {
      this.showRTSMContent = true;
    },
    collapseAll() {
      this.showRTSMContent = false;
    }
  }
};
</script>

<style scoped>
.link_style {
  border-right: 1px solid #959fa4;
  margin: 0px 5px 0px 2px !important;
}
.inner-card {
  border: none;
  margin: 5px 20px;
  border-radius: 3px !important;
  background-color: #d3dfe4;
}
.content {
  font-size: 12px;
  color: #666669;
}
.header {
  font-size: 12px;
  font-weight: bold;
  color: #666669;
}
p {
  margin-top: 0;
  margin-bottom: 0 !important;
}
</style>
